module.exports = __webpack_public_path__ + "img/corriente_a_gray.0ea08378.svg";